import { DateTime } from 'luxon';

import { MovingCheckoutData, StorageCheckoutData } from '../data';

/**
 * Resolves the best available appointment DateTime from checkout values.
 * Prioritizes: dateScheduled > datePreferred > current time
 *
 * @param values - Checkout data (moving or storage)
 * @returns DateTime representing the appointment time
 */
export const resolveAppointmentDateTime = (
  values: MovingCheckoutData | StorageCheckoutData,
): DateTime => {
  if (values.dateScheduled) {
    return DateTime.fromISO(values.dateScheduled.fromTime);
  }

  return values.datePreferred || DateTime.local();
};
